import { environment } from '../../../environments/environment';

export const SEARCH_CONSTANTS = {
  SEARCH_FIELDS: ['desc', 'keywords^15', 'hashtags', 'content'] as const,
  TITLE_MATCH_BOOST: 3,
  TITLE_TERM_BOOST: 5,
  WILDCARD_TITLE_BOOST: 100,
  TYPE_KEYWORD_BOOSTS: (environment.elasticsearch.typeKeywordBoosts || []) as ReadonlyArray<{ name: string; boost: number }>,
};